import { Dashboard } from "api/model/dashboard/Dashboard";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React from "react";
import { T } from "services/lang/LanguageService";

interface TabTitleEditorProps {
  isChangeTabTitleVisible: boolean;
  setIsChangeTabTitleVisible: (isChangeTabTitleVisible: boolean) => void;
  selectedTabTitle: string;
  setSelectedTabTitle: (selectedTabTitle: string) => void;
  dashboard: Dashboard;
  setDashboard: (dashboard: Dashboard) => void;
  tabId: number;
}
const TabTitleEditor = (props: TabTitleEditorProps) => {
  const titleChangeFooter = () => {
    return (
      <div>
        <Button
          label={T("word.cancel")}
          icon="pi pi-times"
          onClick={() => props.setIsChangeTabTitleVisible(false)}
          className="p-button-sm p-button-danger"
        />
        <Button
          label={T("action.save")}
          icon="pi pi-check"
          onClick={() => {
            const updatedCurrentDashboard = {
              ...props.dashboard,
              dashboardTabsJs: [
                ...props.dashboard.dashboardTabsJs.slice(0, props.tabId),
                {
                  ...props.dashboard.dashboardTabsJs[props.tabId],
                  title: props.selectedTabTitle,
                },
                ...props.dashboard.dashboardTabsJs.slice(props.tabId + 1),
              ],
            };
            props.setDashboard(updatedCurrentDashboard);
            props.setIsChangeTabTitleVisible(false);
          }}
          className="p-button-sm p-button-success"
        />
      </div>
    );
  };

  return (
    <div>
      <Dialog
        header={T("action.change-tab-title")}
        style={{ width: "20rem", height: "16rem" }}
        modal
        resizable
        draggable
        visible={props.isChangeTabTitleVisible}
        onHide={() => props.setIsChangeTabTitleVisible(false)}
        footer={titleChangeFooter}
      >
        <div>{props.dashboard.dashboardTabsJs[props.tabId].title}</div>
        <InputText
          value={props.selectedTabTitle}
          className="w-full"
          onChange={e => {
            props.setSelectedTabTitle(e.target.value);
          }}
        />
      </Dialog>
    </div>
  );
};

export default TabTitleEditor;
